import { Link } from "react-router-dom";
import { Linkedin, Instagram, Mail, Phone, MapPin, Clock, Facebook } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="h-1 bg-accent" />

      <div className="container mx-auto px-4 py-12 lg:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="inline-flex flex-col items-start">
              <span className="text-lg font-heading font-semibold leading-none tracking-[0.15em] text-accent">Clarity Within. Success Beyond.</span>
            </Link>
            <p className="mt-3 text-base leading-relaxed text-primary-foreground/70">
              A transformative coaching, training, and consulting firm empowering individuals and organisations.
            </p>
          </div>

          <div>
            <h4 className="mb-3 font-heading text-xl font-semibold text-accent">Quick Links</h4>
            <ul className="space-y-1.5">
              {[
                { label: "Home", to: "/" },
                { label: "About Us", to: "/about" },
                { label: "Services", to: "/services" },
                { label: "Case Studies", to: "/case-studies" },
                { label: "Blog", to: "/blog" },
                { label: "Contact Us", to: "/contact" },
              ].map((l) => (
                <li key={l.to}><Link to={l.to} className="text-base text-primary-foreground/70 transition-colors hover:text-accent">{l.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-3 font-heading text-xl font-semibold text-accent">Services</h4>
            <ul className="space-y-1.5">
              {[
                { label: "Executive Facilitation", to: "/services/companies#executive-facilitation" },
                { label: "Soft Skills Training", to: "/services/companies#campus-to-corporate" },
                { label: "Life Coaching", to: "/services/individuals#life-coaching" },
                { label: "Personal Branding", to: "/services/individuals#personal-branding" },
                { label: "Art Therapy", to: "/services/individuals#art-therapy" },
                { label: "Graphology", to: "/services/individuals#graphology" },
              ].map((l) => (
                <li key={l.label}><Link to={l.to} className="text-base text-primary-foreground/70 transition-colors hover:text-accent">{l.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-3 font-heading text-xl font-semibold text-accent">Contact</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-base text-primary-foreground/70"><Phone className="mt-1 h-4 w-4 shrink-0 text-accent" /><div><p>India: +91 78998 04670</p><p>UAE: +971 55 283 2143</p></div></li>
              <li><a href="mailto:mvibeon@gmail.com" className="flex items-center gap-2 text-base text-primary-foreground/70 transition-colors hover:text-accent"><Mail className="h-4 w-4 shrink-0 text-accent" />mvibeon@gmail.com</a></li>
              <li className="flex items-start gap-2 text-base text-primary-foreground/70"><MapPin className="mt-1 h-4 w-4 shrink-0 text-accent" /><span>Building 12 Bawabat Al Sharq, Baniyas, Abu Dhabi, UAE</span></li>
              <li className="flex items-start gap-2 text-base text-primary-foreground/70"><Clock className="mt-1 h-4 w-4 shrink-0 text-accent" /><div><p>Mon–Fri: 8:00 AM – 12:00 PM (IST)</p><p>Sat–Sun: 9:00 AM – 2:00 PM (IST)</p></div></li>
              <li className="mt-1 flex gap-3">
                <a href="https://www.linkedin.com/company/mvibeon-training-coaching/" target="_blank" rel="noopener noreferrer" className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-full bg-accent text-accent-foreground transition-colors hover:bg-accent/20 hover:text-accent" aria-label="LinkedIn"><Linkedin className="h-5 w-5" /></a>
                <a href="https://www.instagram.com/mvibe_on?igsh=ZjJmNGZnZXNnYWJr" target="_blank" rel="noopener noreferrer" className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-full bg-accent text-accent-foreground transition-colors hover:bg-accent/20 hover:text-accent" aria-label="Instagram"><Instagram className="h-5 w-5" /></a>
                <a href="https://www.facebook.com/profile.php?id=61582267450540" target="_blank" rel="noopener noreferrer" className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-full bg-accent text-accent-foreground transition-colors hover:bg-accent/20 hover:text-accent" aria-label="Facebook"><Facebook className="h-5 w-5" /></a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-foreground/10">
        <div className="container mx-auto flex flex-col items-center justify-between gap-2 px-4 py-3 text-sm text-primary-foreground/50 sm:flex-row lg:px-8">
          <p>Copyright © 2026 MViBE. All Rights Reserved.</p>
          <div className="flex flex-wrap gap-4">
            <Link to="/privacy" className="transition-colors hover:text-accent">Privacy Policy</Link>
            <Link to="/terms" className="transition-colors hover:text-accent">Terms of Service</Link>
            <Link to="/cookies" className="transition-colors hover:text-accent">Cookies</Link>
            <Link to="/disclaimer" className="transition-colors hover:text-accent">Disclaimer</Link>
            <a href="https://zhdqcvukvvevxaihypbm.supabase.co/storage/v1/object/public/cms-images/sitemap.xml" className="transition-colors hover:text-accent" target="_blank" rel="noopener noreferrer">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
